export const MonthChevron = (props: any) => (
    <svg
        width="36"
        height="26"
        viewBox="0 0 36 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8 16.4713C8 16.0528 8.17391 15.7161 8.52174 15.4249L16.5 8.57325C16.9674 8.18198 17.4239 8.0091 18 8C18.5652 8 19.0435 8.18198 19.5 8.57325L27.4891 15.4158C27.8261 15.7161 28 16.0619 28 16.4713C28 17.3085 27.1957 18 26.1957 18C25.6957 18 25.2391 17.818 24.8587 17.5086L17.9891 11.5669L11.1413 17.5086C10.7609 17.8271 10.3043 18 9.80435 18C8.81522 18 8 17.3085 8 16.4713Z"
            fill="white"
        />
    </svg>

);
